import React from 'react';
import {
  Button, Modal
} from 'antd';
import PropTypes from 'prop-types';

const ModalForm = ({
  isModalVisible, handleOk, Form, onFinish
}) => (
  <Modal
    title="Demander un devis"
    visible={isModalVisible}
    onOk={handleOk}
    footer={[
      <Button type="primary" key="Fermer" onClick={handleOk}>
        Annuler
      </Button>,
    ]}
    closable={false}
  >
    <Form onFinish={onFinish} />
  </Modal>
);

ModalForm.propTypes = {
  onFinish: PropTypes.func,
  Form: PropTypes.element,
  isModalVisible: PropTypes.bool,
  handleOk: PropTypes.func
};

export default ModalForm;
